<script>
import DataLayer from '@services/data-layer/index'
import ShowScheduleMixBlock from '@components/show-schedule-mix-block'

export default {
    components: { ShowScheduleMixBlock },
    page() {
        const channelTitle = this.channel.title || 'Channel'
        const title = `History — ${channelTitle}`
        const description = `Recently played mixes on ${channelTitle}.` || `Recently played mixes.`
        const image = `${process.env.VUE_APP_CLIENT_URL}/frisky-social-share-image.png`
        const canonicalUrl = `https://frisky.fm${this.$route.path}`
        return {
            title,
            link: [{ rel: 'canonical', vmid: 'canonical', href: canonicalUrl }],
            meta: [
                { name: 'title', vmid: 'title', content: title },
                { name: 'description', vmid: 'description', content: description },

                { property: 'og:title', vmid: 'og:title', content: title },
                { property: 'og:description', vmid: 'og:description', content: description },
                { property: 'og:image', vmid: 'og:image', content: image },
                { property: 'og:type', vmid: 'og:type', content: 'website' },
                { property: 'og:url', vmid: 'og:url', content: canonicalUrl },
                { property: 'og:site_name', vmid: 'og:site_name', content: 'FRISKY' },

                { name: 'twitter:card', vmid: 'twitter:card', content: 'summary_large_image' },
                { name: 'twitter:title', vmid: 'twitter:title', content: title },
                { name: 'twitter:description', vmid: 'twitter:description', content: description },
                { name: 'twitter:image', vmid: 'twitter:image', content: image },
                { name: 'twitter:url', vmid: 'twitter:url', content: canonicalUrl },
            ],
        }
    },
    data() {
        return {
            stationsPlaylist: Array.from(Array(10), (e, i) => ({
                id: i,
                mixes: {
                    id: i,
                    show: {
                        id: '',
                        title: '',
                        url: '',
                        type: '',
                        image: {},
                        genre: [],
                        artist_id: {},
                        artist: {},
                    },
                },
            })),
        }
    },
    computed: {
        clientTimezoneLabel() {
            return Intl.DateTimeFormat().resolvedOptions().timeZone || 'your local timezone'
        },
    },
    mounted() {
        const yesterday = new Date()
        yesterday.setDate(yesterday.getDate() - 1)

        DataLayer.stationsPlaylists.get(this.$route.params.channelId, yesterday, 60, 0).then(stationsPlaylist => {
            const now = new Date()
            this.stationsPlaylist = stationsPlaylist.body
                .filter(record => new Date(record.scheduled_start_time) < now)
                .reverse()
        })
    },
}
</script>

<template>
    <BaseContent>
        <BaseSection
            title="History"
            padded
        >
            <p :class="$style.timezoneNote">
                Showing times in {{ clientTimezoneLabel }}
            </p>
            <ShowScheduleMixBlock :resources="stationsPlaylist" />
        </BaseSection>
    </BaseContent>
</template>

<style lang="scss" module>
@import '@design';

.timezoneNote {
    @extend %contentSubtitleS;

    margin: 0 0 $s-m;
    color: $c-shuttle-gray;
}
</style>
